import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';

import { LOGOUT } from 'ConstComponents';

import {
    Container,
    Grid,
    CircularProgress,
    Paper,
    FormControl
} from '@material-ui/core';
import {
    Select as SELECT,
    Reconnect as RECONNECT
} from 'Components/Api/XMPPApi';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton } from 'Components/Inputes/CustomButton';

const CustomContainer = HOCLoader(Container);

export const Status = () => {
    const classes = commonStyle();
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    let className;

    const [formObj, setFormObj] = useState({
        HostName: '',
        WebUser: '',
        Status: '',
        OtomaxUser: ''
    });

    useEffect(() => {
        select();
    }, []);

    const select = async () => {
        setLoadingOpen(true);

        setIsError(false);

        var response = await SELECT('');

        setLoadingOpen(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        setFormObj({
            HostName: data.HostName,
            WebUser: data.WebUser,
            Status: data.Status,
            OtomaxUser: data.OtomaxUser
        });
    };

    const submitHandle = async (values, { setSubmitting }) => {
        setLoadingOpen(true);

        setIsError(false);

        var response = await RECONNECT();

        setLoadingOpen(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) {
            setSeverity('error');
            return;
        }
    };

    const Status = ({ value }) => {
        if (value === 'Online') {
            className = classes.success;
        } else if (value === 'PROCESS') {
            className = classes.process;
        } else if (value === 'Offline' || value === 'FAILURE') {
            className = classes.fail;
        }

        return (
            <span
                className={className}
                style={{ marginTop: '10px', padding: '10px' }}
            >
                {value}
            </span>
        );
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObj}
                onSubmit={submitHandle}
            >
                {({ values }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>XMPP </h2>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={1}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialTextField
                                                label="HostName"
                                                name="HostName"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Host Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialTextField
                                                label="Web User"
                                                name="WebUser"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Web User"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={1}
                                            lg={1}
                                        >
                                            <FormControl fullWidth>
                                                <Status
                                                    value={values.Status}
                                                    fullWidth
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <MaterialTextField
                                                label="Otomax User"
                                                name="OtomaxUser"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Otomax User"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Reconnect XMPP"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loadingOpen}
                                            >
                                                Reconnect XMPP
                                            </PrimaryButton>
                                            {loadingOpen && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
